module.exports = __webpack_public_path__ + "static/img/case_detail_04_4.a94c14e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_04_4.png
// module id = lqZG
// module chunks = 34